const MODULE_NAME = 'fulcrum/container/Role/Global'
const CHANGE_GLOBAL_ROLE = 'fulcrum/container/Role/Global/CHANGE_GLOBAL_ROLE'
const CHANGE_GLOBAL_ROLE_SUCCESS = 'fulcrum/container/Role/Global/CHANGE_GLOBAL_ROLE_SUCCESS'
const CHANGE_GLOBAL_ROLE_START = 'fulcrum/container/Role/Global/CHANGE_GLOBAL_ROLE_START'
const UPDATE_GLOBAL_ROLE = 'fulcrum/container/Role/Global/UPDATE_GLOBAL_ROLE'
const UPDATE_PROJECT_ROLE = 'fulcrum/container/Role/Global/UPDATE_PROJECT_ROLE'
const UPDATE_DATA_MANAGER_ROLE = 'fulcrum/container/Role/Global/UPDATE_DATA_MANAGER_ROLE'
const UPDATE_CLIENT_ROLE = 'fulcrum/container/Role/Global/UPDATE_CLIENT_ROLE'

export {
  MODULE_NAME,
  CHANGE_GLOBAL_ROLE,
  CHANGE_GLOBAL_ROLE_START,
  CHANGE_GLOBAL_ROLE_SUCCESS,
  UPDATE_GLOBAL_ROLE,
  UPDATE_PROJECT_ROLE,
  UPDATE_DATA_MANAGER_ROLE,
  UPDATE_CLIENT_ROLE,
}
